import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[fallbackSrc]',
  standalone: true,
})
export class FallbackImageSourceDirective {
  // injectables
  private readonly element = inject(ElementRef);
  // inputs
  public readonly fallbackSrc = input<string>(undefined);
  // host bindings
  @HostListener('error')
  public loadFallbackOnError() {
    const element: HTMLImageElement = this.element.nativeElement;
    element.src = this.fallbackSrc();
  }
}
